'use client'

import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'

interface EmojiPickerProps {
  onSelect: (emoji: any) => void
  disabled?: boolean
  children?: React.ReactNode
  [key: string]: any
}

export const EmojiPicker = ({ onSelect, disabled, children, ...props }: EmojiPickerProps) => {
  const handleSelect = (emoji: any) => {
    onSelect(emoji.native)
  }

  return (
    <Popover>
      <PopoverTrigger
        asChild
        className="flex size-8.5 items-center justify-center rounded-full"
        disabled={disabled}
      >
        {children}
      </PopoverTrigger>
      <PopoverContent className="z-500 w-full p-0">
        <Picker data={data} emojiSize={20} theme="dark" onEmojiSelect={handleSelect} {...props} />
      </PopoverContent>
    </Popover>
  )
}
